import { VoucherPrintOrgHeading, VoucherPrintOrgAddress, VoucherPrintDepartmentFooter } from "../VoucherPrintOrgHeader";
import PrintCommon from "app/common/Component/Print/PrintCommon";
import {
  VOUCHER_INVOICE_TYPE,
  VOUCHER_INVOICE_TYPE_VALUE,
} from "app/common/LocalConst";
import { formatMoney, formatPrintPatientCodeSuffix, getDateTime, hideMiddleDigits } from "app/common/LocalFunction";
import React, { memo } from "react";
import QrSurveySection from "app/common/Component/Print/QrSurveySection";

const PrintFormA5s = ({
  componentRef,
  dataVoucherFee,
  initialPatient,
  staffRevenues,
}) => {
  const namesText = staffRevenues
    ?.map((item) => item?.staff?.staffName)
    .join(" ; ");

  return (
    <>
      <PrintCommon
        ref={componentRef}
        marginPage="8mm"
        hidden={false}
        size="A5"
        orientation={"landscape"}
      >
        <header className="printHeader w-100 flex justify-between print-voucher">
          <table className="table-layout-fixed">
            <div className="wraper-print">
              <div className="container-print">
                <VoucherPrintOrgHeading department={dataVoucherFee?.department} withDepartmentName />
                <VoucherPrintOrgAddress department={dataVoucherFee?.department} phonePrefix="Điện Thoại: " />
                <div className="mt-5 text-center">
                  <h4 style={{ fontWeight: "bold", fontSize: "16px" }}>
                    PHIẾU THU
                  </h4>
                  <div className="center">
                    {getDateTime(dataVoucherFee?.voucherDate, "", "DD/MM/YYYY")}
                  </div>
                </div>
              </div>
            </div>
          </table>
        </header>
        <div className="cards-container flex justify-center">
          <div className="container-print-A5">
            <table
              border="0"
              cellPadding="1"
              cellSpacing="0"
              style={{
                width: "100%",
                fontFamily: "Arial, sans-serif",
                fontSize: "14px",
                borderSpacing: "0px 4px",
              }}
            >
              {/* Số phiếu: <mã> (dd/MM/yyyy)  Khách hàng: <tên> - <sđt> */}
              <tbody>
                <tr>
                  <td style={{ width: "50%" }}>
                    Số phiếu:{" "}
                    <b>
                      {dataVoucherFee?.code || "Chưa có mã"}{" "}
                      {getDateTime(dataVoucherFee?.voucherDate, "", "DD/MM/YYYY")}
                    </b>
                  </td>
                  <td style={{ width: "50%" }}>
                    Khách hàng:{" "}
                    <b>
                      {dataVoucherFee?.patient?.displayName || ""}{" "}
                      {formatPrintPatientCodeSuffix(dataVoucherFee?.patient, initialPatient)}
                      {dataVoucherFee?.patient?.phoneNumber
                        ? ` - ${hideMiddleDigits(dataVoucherFee?.patient?.phoneNumber)} `
                        : ""}
                    </b>
                  </td>
                </tr>
                <tr>
                  {console.log("dataVoucherFee", dataVoucherFee)}
                  <td>
                    Nhân viên:{" "}
                    {dataVoucherFee?.accountant?.staffName
                      ? `${dataVoucherFee?.accountant?.staffName} ${dataVoucherFee?.accountant?.position
                        ? `(${dataVoucherFee?.accountant?.position?.name})`
                        : ""
                      } `
                      : "Không rõ"}
                  </td>
                  <td>
                    <td>Tư vấn: {namesText}</td>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="table-responsive">
              <table className="service-table">
                <thead>
                  <tr>
                    <th>STT</th>
                    <th>TÊN HÀNG</th>
                    <th>ĐƠN VỊ</th>
                    <th>SL</th>
                    <th>ĐƠN GIÁ</th>
                    <th>KHUYẾN MÃI</th>
                    <th>THÀNH TIỀN</th>
                  </tr>
                </thead>
                <tbody>
                  {dataVoucherFee?.items?.length > 0 ? (
                    dataVoucherFee?.items?.map((it, index) => (
                      <React.Fragment key={it.id || index}>
                        <tr>
                          <td>{index + 1}</td>
                          <td>
                            {it?.invoiceItem?.invoiceItemRegisterName
                              ? it?.invoiceItem?.invoiceItemRegisterName
                              : it?.invoiceItem?.invoiceItemName}
                          </td>
                          <td></td>
                          <td>{it?.invoiceItem?.quantity}</td>
                          <td>{formatMoney(it?.invoiceItem?.currentFee)}</td>
                          <td>
                            {formatMoney(
                              it?.invoiceItem?.discount +
                              it?.invoiceItem?.allocateDiscount || 0
                            )}
                          </td>
                          <td>
                            {formatMoney(
                              it?.invoiceItem?.subAmountActuallyPaid || 0
                            )}
                          </td>
                        </tr>
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4}>Không có dữ liệu</td>
                    </tr>
                  )}
                </tbody>
                <tfoot style={{ border: "1px solid #ccc" }}>
                  <tr>
                    <td
                      colSpan={3}
                      rowSpan={4}
                      style={{
                        verticalAlign: "top",
                        border: "none",
                        paddingTop: 4,
                      }}
                    >
                      <b>Ghi chú:</b>
                      {dataVoucherFee?.note || "Không có ghi chú"}
                    </td>
                    <td
                      colSpan={3}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      <b>Tổng tiền (VNĐ):</b>
                    </td>
                    <td
                      colSpan={2}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      {formatMoney(dataVoucherFee?.actuallyTotalAmount)}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan={3}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      <b>Khách Hàng Trả:</b>
                    </td>
                    <td
                      colSpan={2}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      {formatMoney(dataVoucherFee?.customerPaidAmount)}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan={3}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      <b>Đã Thanh Toán:</b>
                    </td>
                    <td
                      colSpan={2}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      {formatMoney(dataVoucherFee?.amountPaid)}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan={3}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      <b>Còn nợ:</b>
                    </td>
                    <td
                      colSpan={2}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      {formatMoney(dataVoucherFee?.remainingDebt)}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <div
                style={{
                  textAlign: "center",
                  fontSize: "0.75rem",
                  textTransform: "uppercase",
                }}
              >
                <i>
                  Quý khách vui lòng kiểm tra dịch vụ/sản phẩm trước khi rời
                  khỏi quầy. Sản phẩm sẽ không được đổi trả. Khi khách hàng
                  tự ý ngưng dịch vụ sẽ không được hoàn lại tiền mà sẽ được
                  tư vấn chuyển sang dịch vụ khác. Dịch vụ có thời hạn sử
                  dụng trong vòng 12 tháng kể từ thời điểm thu tiền và xuất
                  hóa đơn. Xin cảm ơn Quý khách và hẹn gặp lại !!!
                </i>
              </div>
              <QrSurveySection patient={dataVoucherFee?.patient} />
            </div>
          </div>
        </div>
      </PrintCommon>
    </>
  );
};

export default memo(PrintFormA5s);
